import { WorkflowFormFieldInputCheckbox } from './list/inputCheckbox';
import { WorkflowFormFieldInputDate } from './list/inputDate';
import { WorkflowFormFieldInputDatetime } from './list/inputDatetime';
import { WorkflowFormFieldInputFiles } from './list/inputFiles';
import { WorkflowFormFieldInputNumber } from './list/inputNumber';
import { WorkflowFormFieldInputRadio } from './list/inputRadio';
import {
  WorkflowFormFieldInputMultiselect,
  WorkflowFormFieldInputSelect,
} from './list/inputSelects';
import { WorkflowFormFieldInputString } from './list/inputString';
import { WorkflowFormFieldInputPhotos } from './list/inputPhotos';
import { WorkflowFormFieldInputActualAddress } from './list/inputActualAddress';
import { WorkflowFormFieldInputDealDetails } from './list/inputDealDetails';
import { WorkflowFormFieldInputButton } from './list/inputButton';
import { WorkflowFormFieldInputDevices } from './list/inputDevices';

// Поля, которые будут заполняться пользователем в форме конкретного регламента
export type WorkflowFormFieldInput =
  | WorkflowFormFieldInputNumber
  | WorkflowFormFieldInputString
  | WorkflowFormFieldInputDate
  | WorkflowFormFieldInputDatetime
  | WorkflowFormFieldInputCheckbox
  | WorkflowFormFieldInputRadio
  | WorkflowFormFieldInputSelect
  | WorkflowFormFieldInputMultiselect
  | WorkflowFormFieldInputFiles
  | WorkflowFormFieldInputPhotos
  | WorkflowFormFieldInputDealDetails
  | WorkflowFormFieldInputActualAddress
  | WorkflowFormFieldInputDevices
  | WorkflowFormFieldInputButton;

export const WORKFLOW_FORM_FIELD_INPUT_TYPES = {
  inputCheckbox: 'inputCheckbox',
  inputDate: 'inputDate',
  inputDatetime: 'inputDatetime',
  inputFiles: 'inputFiles',
  inputNumber: 'inputNumber',
  inputPhotos: 'inputPhotos',
  inputRadio: 'inputRadio',
  inputSelect: 'inputSelect',
  inputMultiselect: 'inputMultiselect',
  inputString: 'inputString',
  inputDealDetails: 'inputDealDetails',
  inputActualAddress: 'inputActualAddress',
  inputDevices: 'inputDevices',
  inputButton: 'inputButton',
} as const;
